import React from "react";

/**
 * Brand SVG glyphs for the Mission Hub — replaces raw emoji so the hub matches
 * the premium gold Golden Clover identity. All icons inherit `currentColor`
 * and size to their container via width/height props (default 1em).
 */

const base = (size) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  focusable: "false",
  "aria-hidden": "true",
});

export function BoltIcon({ size = "1em", className = "" }) {
  return (
    <svg {...base(size)} className={className} fill="currentColor">
      <path d="M13 2 4.5 13.2a.7.7 0 0 0 .56 1.12H10l-1.4 7.06a.4.4 0 0 0 .72.3L19.5 10.5a.7.7 0 0 0-.56-1.12H14l1.28-6.9a.4.4 0 0 0-.72-.32L13 2Z" />
    </svg>
  );
}

export function FlameIcon({ size = "1em", className = "" }) {
  return (
    <svg {...base(size)} className={className} fill="currentColor">
      <path d="M12 2c.7 2.9-.8 4.6-2.2 6.1C8.2 9.8 7 11.3 7 13.6A5 5 0 0 0 12 22a5 5 0 0 0 5-5.4c-.1-1.8-1-3.2-1.9-4.3-.3.9-.9 1.6-1.7 2 .5-1.8.2-3.9-1.2-5.6C10.9 7 10.7 5 12 2Z" />
    </svg>
  );
}

export function CloverIcon({ size = "1em", className = "" }) {
  return (
    <svg {...base(size)} className={className} fill="currentColor">
      <ellipse cx="12" cy="6" rx="3" ry="3.6" />
      <ellipse cx="16" cy="10" rx="3.6" ry="3" />
      <ellipse cx="12" cy="14" rx="3" ry="3.6" />
      <ellipse cx="8" cy="10" rx="3.6" ry="3" />
      <rect x="11.4" y="13" width="1.2" height="8" rx=".6" />
    </svg>
  );
}

export function GiftIcon({ size = "1em", className = "" }) {
  return (
    <svg {...base(size)} className={className} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3.5" y="9" width="17" height="12" rx="1.5" />
      <path d="M3.5 13h17M12 9v12" />
      <path d="M12 9C10 9 7.5 8.4 7.5 6.2 7.5 5 8.5 4 9.7 4c1.7 0 2.3 2.6 2.3 5Z" />
      <path d="M12 9c2 0 4.5-.6 4.5-2.8C16.5 5 15.5 4 14.3 4 12.6 4 12 6.6 12 9Z" />
    </svg>
  );
}

export function TargetIcon({ size = "1em", className = "" }) {
  return (
    <svg {...base(size)} className={className} fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="12" cy="12" r="4.6" />
      <circle cx="12" cy="12" r="1.1" fill="currentColor" stroke="none" />
    </svg>
  );
}

export function PlayIcon({ size = "1em", className = "" }) {
  return (
    <svg {...base(size)} className={className} fill="currentColor">
      <path d="M8 5.2a1 1 0 0 1 1.53-.85l9 6.8a1 1 0 0 1 0 1.7l-9 6.8A1 1 0 0 1 8 18.8V5.2Z" />
    </svg>
  );
}
